import { INSURER_CONFIG } from '@shared/insurer';
export function isCountingMode() {
    var _a;
    return ((_a = INSURER_CONFIG.backoffice) === null || _a === void 0 ? void 0 : _a.mode) === 'countings';
}
export function getPecuniaryCompensationURL(claimId, locale) {
    let path = '/compensation_presentation';
    if (locale)
        path += `/${locale}`;
    path += `/${claimId}`;
    const searchParams = new URLSearchParams({ compensationMode: 'pecuniary' });
    return `${path}?${searchParams.toString()}`;
}
export function getSelfRepairCompensationURL(claimId, locale) {
    let path = '/compensation_presentation';
    if (locale)
        path += `/${locale}`;
    path += `/${claimId}`;
    const searchParams = new URLSearchParams({ compensationMode: 'self-repair' });
    return `${path}?${searchParams.toString()}`;
}
export function getDefaultCompensationURL(claimId) {
    const path = `/compensation_presentation/${claimId}`;
    return `${path}`;
}
